import React, { Component } from "react";
// import {Link} from 'react-router-dom'
class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: [
        {
          id: 1,
          classname: "profile-link border-corner2 d-flex align-items-center",
          images: "https://img.icons8.com/fluency/60/000000/facebook-new.png",
          alt: "images",
          name: "Facebook",
          normal: "Let's be friends",
          href: "https://www.facebook.com/suman.giri.1023",
        },
        {
          id: 2,
          classname: "profile-link border-corner2 d-flex align-items-center",
          images: "https://img.icons8.com/fluency/60/000000/instagram-new.png",
          alt: "images",
          name: "Instagram",
          normal: "Follow me",
          href: "https://www.instagram.com/suman_kumar_giri/?hl=en",
        },
        {
          id: 3,
          classname: "profile-link border-corner2 d-flex align-items-center",
          images: "https://img.icons8.com/fluency/60/000000/twitter.png",
          alt: "images",
          name: "Tweeter",
          normal: "Tweeter Account",
          href: "https://twitter.com/SumaN2point0",
        },
        {
          id: 4,
          classname: "profile-link border-corner2 d-flex align-items-center",
          images: "https://img.icons8.com/fluency/60/000000/linkedin.png",
          alt: "images",
          name: "LinkedIn",
          normal: "Connect with me",
          href: "https://www.linkedin.com/in/suman-giri-/",
        },
      ],
    };
  }
  render() {
    return (
      <div className="background-white">
        <div className="d-lg-flex">
          <div className="col-left">
            <div
              className="featured-post animate-element wow delay5 fadeInUp"
              data-wow-delay="0.5s"
            >
              <iframe
                title={"address"}
                class="iFrame"
                width="300"
                height="300"
                src="https://embed.lottiefiles.com/animation/8772"
              ></iframe>
            </div>
          </div>
          <div className="col-right">
            <div
              className="flat-spacer"
              data-desktop="105"
              data-mobile="50"
              data-smobile="50"
            ></div>
            <div className="flat-title t1">
              <div
                className="animate-element wow delay5 fadeInDown"
                data-wow-delay="0.5s"
              >
                <h4 className="sub-title mg-b22">About Me</h4>
                <h2 className="title-section mg-b26 color-d12">
                  Hi, I am Suman Giri{" "}
                  <span className="color-d4">Welcome to my portfolio.</span>
                </h2>
                <p>
                  I'm from Odisha, Balasore. I have persued my graduation in
                  Physics. Now I'm a Full-Stack Web Developer studied in Masai
                  School, Bengaluru. Currently working in Agile Soft Systems,
                  Looking for opportunity to work with some cool people around.
                </p>
              </div>
              <div
                className="animate-element wow delay5 fadeInUp"
                data-wow-delay="0.5s"
              >
                <div className="fl-btn btn-general">
                  <a
                    href="mailto:girisuman289@gmail.com"
                    target="_blank"
                    rel="noreferrer"
                    className="f-w500 color-1 lt-sp07"
                  >
                    Hire Me
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="profile-list">
          <div
            className="flat-carousel-box data-effect clearfix"
            data-gap="30"
            data-column="4"
            data-column2="3"
            data-column3="2"
            data-column4="1"
            data-column5="1"
            data-dots="false"
            data-auto="false"
            data-nav="false"
            data-loop="true"
          >
            <div className="owl-carousel">
              {this.state.profile.map((data) => (
                <div className={data.classname} key={data.id}>
                  <div className="featured-post">
                    <img src={data.images} alt={data.alt} />
                  </div>
                  <div className="content-inside">
                    <h3 className="name">
                      <a href={data.href} target="_blank" rel="noreferrer">
                        {data.name}
                      </a>
                    </h3>
                    <span className="t-normal">{data.normal}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;
